<script context="module">
  import Button from "../../atoms/Button.svelte";
  import Checkbox from "./Checkbox.svelte";
  import Input from "./Input.svelte";
  import HiddenInput from "./HiddenInput.svelte";
  import Textarea from "./Textarea.svelte";

  export const FIELD_COMPONENT_MAP = {
    text: Input,
    email: Input,
    number: Input,
    checkbox: Checkbox,
    textarea: Textarea,
    hidden: HiddenInput,
    submit: Button
  };
</script>

<script>
  // @ts-check
  /**
   * @type {keyof typeof FIELD_COMPONENT_MAP}
   */
  export let type = "text";
</script>

<svelte:component
  this={FIELD_COMPONENT_MAP[type]}
  {type}
  on:focus
  on:invalid
  on:click
  {...$$restProps}
>
  <slot />
</svelte:component>
